import axios from '@/libs/api.request'

export const GetMachine = data => {
  return axios.request({
    url: '/company/machine',
    method: 'get',
    params: data,
  })
}

export const MachineError = data => {
  return axios.request({
    url: '/print/machine/error/info',
    params: data,
    method: 'get'
  })
}

export const MachineErrorList = data => {
  return axios.request({
    url: '/print/machine/error',
    params: data,
    method: 'get'
  })
}